import { render } from "./CheckoutMagic.vue?vue&type=template&id=125bf2cc"
import script from "./CheckoutMagic.vue?vue&type=script&lang=js"
export * from "./CheckoutMagic.vue?vue&type=script&lang=js"

import "./CheckoutMagic.vue?vue&type=style&index=0&id=125bf2cc&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__